import { render, staticRenderFns } from "./GetVat.vue?vue&type=template&id=199e492c&scoped=true"
import script from "./GetVat.vue?vue&type=script&lang=js"
export * from "./GetVat.vue?vue&type=script&lang=js"
import style0 from "./GetVat.vue?vue&type=style&index=0&id=199e492c&lang=less&scoped=true"
import style1 from "./GetVat.vue?vue&type=style&index=1&id=199e492c&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199e492c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199e492c')) {
      api.createRecord('199e492c', component.options)
    } else {
      api.reload('199e492c', component.options)
    }
    module.hot.accept("./GetVat.vue?vue&type=template&id=199e492c&scoped=true", function () {
      api.rerender('199e492c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/GetVat.vue"
export default component.exports